<template>
  <div class="flex flex-column align-items-center ">
    <SuccessAndFail :msjEnable.sync="msjEnable" :mensajeDialog="mensaje" :buttomAceptar="buttomAceptar"
      :buttomCancelar="buttomCancelar" :icon.sync="iconModal" @Aceptar="ClickAceptar" :aceptar="aceptarLabel"
      :cancelar="cancelarLabel" />
    <!-- Main -->
    <div v-if="!datosCargados" class="overlay-cargando">
      <ProgressSpinner style="width: 60px; height: 60px;" strokeWidth="5" />
    </div>
    <div class="w-11 bg-white shadow-2 py-1 px-3"  v-else>
      <div class="align-items-center flex flex-column ">
        <div class="flex justify-content-between w-full align-items-center">
          <h2>{{ formatNameUFI(this.resumen.formType) }} - {{ sumario.causaNumero }} - {{ sumario.dependenciaPolicial }}</h2>
        </div>
        <TabView class="w-full card" :key="resumen?.formType" @tab-change="onTabChange" :activeIndex="tabIndex" >
          <TabPanel header="Datos Legales" >
            <SplitButton
              v-if="getItems().length"
              label="Acciones"
              :model="getItems()"
              class="p-button-raised "
              style="float: right;"
            />
            <div class="flex">
              <div class="w-6 flex flex-column px-3">
                <h2>Datos Legales</h2>
                <BlockUI :blocked="modalSpinner" :fullScreen="true">
                  <Dialog
                    :visible="displayModal"
                    :style="{ width: '500px' }"
                    :contentStyle="{ maxHeight: '500px' }"
                    :modal="true"
                    :closable="false"
                    ref="modalUpdateRef"
                  >
                    <template #header>
                      <div class="flex flex-column justify-content-center align-items-center w-full">
                        <i :class="getIcon()" :style="{ fontSize: '4rem', color: getIconColor() }" />
                        <p class="font-bold text-xl text-center w-full">{{ modalAttributes.title }}</p>
                        <span class="flex align-items-center justify-content-center text-center">
                          {{ modalAttributes.message }}
                        </span>
                      </div>                   
                    </template>
                    <div class="field" v-if="modalAttributes.showMo && !confirmationMode">
                      <p class="m-0">Seleccione {{ modalAttributes.new }} {{ modalAttributes.type }}</p>
                      <div class="field" :test-id="modalAttributes.divTestId">
                        <Dropdown
                          v-if="modalAttributes.form === 'Dropdown'"
                          :dataKey="modalAttributes.dataKey"
                          :placeholder="modalAttributes.type"
                          v-model="selectedDropdownValue"
                          @change="
                            changeModal([$event, modalAttributes.vModel, 'ModalDropdown']);
                            selectedDropdownValue = $event.value;
                          "
                          :options="modalAttributes.optionsList"
                          :optionLabel="modalAttributes.optionLabel"
                          :test-id="modalAttributes.testId"
                          :filter="true"
                          ref="ModalDropdown"
                          appendTo="body"
                        />
                        <InputText
                          v-if="modalAttributes.form === 'InputText'"
                          type="text"
                          :placeholder="modalAttributes.type"
                          @change="changeModal([$event, modalAttributes.vModel, 'ModalInputText'])"
                          :value="this[modalAttributes.vModel]"
                          :test-id="modalAttributes.testId"
                          ref="ModalInputText"
                        />
                      </div>
                      <div>
                        <div
                          class="field containerArticulos"
                          v-if="this[modalAttributes.arrayItems.arrayName].length > 0"
                        >
                          <div
                            class="listaArticulos"
                            v-for="item in this[modalAttributes.arrayItems.arrayName]"
                            :key="item[modalAttributes.arrayItems.id]"
                          >
                            <div class="articulo__nombre">
                              <p>
                                {{ modalAttributes.arrayItems.attribute1.text }}
                                {{ item[modalAttributes.arrayItems.attribute1.prop] }}
                                {{ modalAttributes.arrayItems.attribute2.text }}
                                {{ item[modalAttributes.arrayItems.attribute2.prop] }}
                              </p>
                            </div>
                            <div class="btn">
                              <Button
                                icon="pi pi-trash"
                                class="md:col-4 p-button-text"
                                @click="
                                  isOnlineActuacion() &&
                                    deleteModalItem(item[modalAttributes.arrayItems.id])
                                "
                                style="
                                  color: white;
                                  width: 30px;
                                  height: 30px;
                                  background-color: #dc3545;
                                  margin: 3px;
                                "
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <template #footer>
                      <div v-if="isOnlineActuacion()" class="w-full flex justify-content-end gap-2">
                        <Button
                          test-id="cancelUpdate"
                          label="Cancelar"
                          @click="closeModal"
                          class="bg-transparent text-gray-900 font-medium border-600 border-round-lg w-5" 
                        />
                        <Button
                          test-id="saveUpdate"
                          :label="modalSpinner ? '' : 'Guardar'"
                          @click="saveModalData"
                          autofocus
                          :disabled="isSaveDisabled()"
                          class="border-round-lg w-5 flex justify-content-center align-items-center" 
                        >
                          <i v-if="modalSpinner" class="pi pi-spin pi-spinner mr-2" style="font-size: 1rem"></i>
                        </Button>
                      </div>
                    </template>
                  </Dialog>
                </BlockUI>
                <!-- Legajo Año -->
                <div class="flex w-full justify-content-between align-items-center gap-2">
                  <div class="field w-9">
                    <span class="p-input-icon-right flex flex-column">
                      <label for="sitio">Legajo N° / N° de extracto</label>
                      <InputText id="sitio" type="text" v-model="legajoNroResumen" readonly  />
                      <i
                        v-if="sumario.causaNumero && authorizedUserActuacion(usersAllowedToEdit) && isOnlineActuacion()"
                        v-tooltip.bottom="'Cambiar por…'"
                        @click="openModal('N° de Actuación')"
                        class="pi pi-pencil"
                        style="color:rgba(255, 168, 0, 1)"
                      />
                    </span>
                  </div>
                  <div class="field w-3">
                    <span class="p-input-icon-right flex flex-column">
                      <label for="año">Año</label>
                      <InputText id="año" type="text" v-model="yearResumen" readonly  />
                    </span>
                  </div>
                </div>
                <div class="field">
                  <span class="p-input-icon-right flex flex-column">
                    <label for="sitio">Sitio</label>
                    <InputText id="sitio" type="text" v-model="sitioResumen" readonly  test-id="sitio"/>
                  </span>
                </div>
                <div class="field" v-if="!resumen.formType.includes('Expediente')">
                  <span class="p-input-icon-right flex flex-column">
                    <label for="modusoperandi">Modus operandi</label>
                    <InputText id="modusoperandi" type="text" v-model="resumen.modusOperandi" readonly  test-id="modusOperandi"/>
                  </span>
                </div>
                <div class="field">
                  <span class="p-input-icon-right flex flex-column">
                    <label
                      v-if="resumen.formType.includes('Expediente')"
                      for="causacaratula">
                      Carátula del expediente
                    </label>
                    <label
                      v-else-if="!resumen.formType.includes('Unidades Fiscales de Investigacion') || resumen.formType.includes('UFI')"
                      for="causacaratula">
                      Causa/Carátula
                    </label>
                    <label v-else for="causacaratula">Delito</label>
                    <InputText
                      id="causacaratula"
                      type="text"
                      readonly
                      v-model="caratulasResumen"
                      test-id="causaCaratula"
                    />
                    <i
                      v-if="isOnlineActuacion() &&
                          authorizedUserActuacion(['Super User', 'SecretarioActual', 'Jefe de Sumario'].concat(prosecutorUserTypes)
                      )"
                      v-tooltip.bottom="'Cambiar por…'"
                      @click="openModal('Caratula')"
                      class="pi pi-pencil"
                      style="color:rgba(255, 168, 0, 1)"
                    />
                  </span>
                    <div>
                      <div class="field containerArticulos">
                        <div class="listaArticulos" v-if="sumario.listaArticulos" v-for="item in arrayArticulos">
                          <div class="articulo__nombre">
                            <p class="font-bold">
                              {{ item }}
                            </p>
                          </div>
                        </div>
                        <div class="listaArticulos" v-if="!sumario.listaCaratulas" v-for="item in arrayCausaCaratula">
                          <div class="articulo__nombre">
                            <p class="font-bold">
                              {{ item.Nombre }}
                            </p>
                          </div>
                        </div>
                        <div class="listaArticulos" else>
                          <div class="articulo__nombre">
                            <p class="font-bold">
                              {{ resumen.listaCaratulas ? resumen.listaCaratulas : resumen.caratula }}
                            </p>
                          </div>

                        </div>
                      </div>
                    </div>
                </div>
                <div class="field" v-if="resumen.formType.includes('Preliminar')">
                  <span>
                    <label for="interviniente">Interviniente</label>
                    <InputText
                      id="interviniente"
                      v-if="typeof resumen?.juzgado === 'object'"
                      v-model="resumen.juzgado.Nombre"
                      readonly
                    />
                    <InputText
                      id="interviniente"
                      v-else
                      v-model="juzgadoResumen"
                      readonly
                      test-id="interviniente"
                    />
                    <i
                      v-if="authorizedUserActuacion(usersAllowedToEdit) && isOnlineActuacion()"
                      v-tooltip.bottom="'Cambiar por…'"
                      @click="openModal('Juzgado interviniente')"
                      class="pi pi-pencil"
                      style="color:rgba(255, 168, 0, 1)"
                    />
                  </span>
                </div>
                <!-- UFI -->
                <div v-else-if="resumen.formType.includes('Unidades Fiscales')">
                  <span class="p-input-icon-right flex flex-column">
                    <label for="interviniente">UFI N°</label>
                    <InputText
                      id="interviniente"
                      v-if="typeof resumen?.juzgado === 'object'"
                      v-model="resumen.juzgado.Nombre"
                      readonly
                    />
                    <InputText
                      id="interviniente"
                      v-else
                      v-model="ufiResumen"
                      readonly
                    />
                    <i
                      v-if="authorizedUserActuacion(usersAllowedToEdit) && isOnlineActuacion()"
                      v-tooltip.bottom="'Cambiar por…'"
                      @click="openModal('Ufi Interviniente')"
                      class="pi pi-pencil"
                      style="color:rgba(255, 168, 0, 1)"
                    />
                  </span>
                  <span class="p-input-icon-right flex flex-column">
                    <label for="prosecutor">Fiscal a Cargo</label>
                    <InputText
                      id="prosecutor"
                      v-model="fiscalResumen"
                      readonly
                    />
                    <i
                      v-if="authorizedUserActuacion(usersAllowedToEdit) && isOnlineActuacion()"
                      v-tooltip.bottom="'Cambiar por…'"
                      @click="openModal('Fiscal')"
                      class="pi pi-pencil"
                      style="color:rgba(255, 168, 0, 1)"
                    />
                  </span>
                  <span class="p-input-icon-right flex flex-column">
                    <label for="assistant">Ayudante Fiscal</label>
                    <InputText
                      id="assistant"
                      v-model="assistantResumen"
                      readonly
                    />
                    <i
                    v-if="
                      authorizedUserActuacion([
                        'Super User',
                        'SecretarioActual',
                        'Jefe de Sumario',
                        'Jefe de Dependencia',
                      ]) && isOnlineActuacion()
                    "
                      v-tooltip.bottom="'Cambiar por…'"
                      @click="openModal('Ayudante Fiscal')"
                      class="pi pi-pencil"
                      style="color:rgba(255, 168, 0, 1)"
                    />
                  </span>
                </div>
                <!-- Juzgado -->
                <div v-else>
                  <span class="p-input-icon-right flex flex-column">
                    <label for="interviniente">Juzgado Interviniente</label>
                    <InputText
                      id="interviniente"
                      v-if="typeof resumen?.juzgado === 'object'"
                      v-model="resumen.juzgado.Nombre"
                      readonly
                    />
                    <InputText
                      id="interviniente"
                      v-else
                      v-model="resumen.juzgado"
                      readonly
                      test-id="juzgadoInterviniente"
                    />
                    <i
                      v-if="authorizedUserActuacion(usersAllowedToEdit) && isOnlineActuacion()"
                      v-tooltip.bottom="'Cambiar por…'"
                      @click="openModal('Juzgado interviniente')"
                      class="pi pi-pencil"
                      style="color:rgba(255, 168, 0, 1)"
                    />
                  </span>
                </div>
              </div>
              <div class="w-6 flex flex-column px-3">
                  <h2>Datos Genéricos</h2>
                  <label for="secretarioActual">Secretario Actual</label>
                  <InputText 
                    id="secretarioActual" 
                    type="text" 
                    :value="secretarioActualString"
                    readonly
                    test-id="secretarioActual"
                  />
                  <label for="secretarioOriginal" class="mt-3">Secretario Original</label>
                  <InputText
                    id="secretarioOriginal"
                    type="text"
                    :value="secretarioOriginalString"
                    readonly
                    test-id="secretarioOriginal"
                  />
                  <Tag 
                  test-id="tagEstadoSumario" 
                  :severity="colorActive()" 
                  :value="sumario.sumarioEstado"
                  style="font-size: 20px" 
                  class="mt-3" 
                  />
                </div>
            </div>
          </TabPanel>
          <TabPanel header="Gestión de diligencias y archivos">
            <div class="w-full flex justify-content-between align-items-center">
              <h2>Gestión de diligencias y archivos</h2>
                <SplitButton
                  v-if="getItems().length"
                  label="Acciones"
                  :model="getItems()"
                  class="p-button-raised "
                />
            </div>
            <div class="table-diligence md:col-12" style="background-color: rgba(248, 249, 250, 1);">
                <DataTable
                  ref="doubleEllipsisIcon"
                  :value="filesAndDiligences"
                  :loading="loading"
                  test-id="diligenciasTable"
                  @row-reorder="onRowReorder"
                  responsiveLayout="scroll"
                >
                  <div id="double-ellipsis-icon-id">
                    <Column
                      :rowReorder="orderBy.nombre !== 'Fecha' && !sumario.spinnerOrderTablePrintFrom"
                      headerStyle="width: 3rem"
                      :reorderableColumn="false"
                      rowReorderIcon="double-ellipsis-icon"
                    />
                  </div>
                  <template #header>
                    <div class="table-header flex justify-content-between align-items-center">
                      <div style="margin-top: -25px">
                        <p style="margin-left: 7px">Ordenar Por:</p>
                        <Dropdown
                          test-id="orderByDropDown"
                          style="margin-top: 1px"
                          class="input-order lg:col-5 md:col-7 sm:col-12"
                          v-model="orderBy"
                          :options="orderList"
                          optionLabel="nombre"
                          placeholder="Orden"
                        />
                      </div>
                      <div test-id="saveOrderButton">
                        <Button
                          type="button"
                          v-if="orderBy.nombre === 'Impresión'"
                          class="p-button-success mr-2 mt-buttons"
                          @click="updateOrderTableDataBase"
                          :disabled="sumario.spinnerOrderTablePrintFrom"
                          >{{
                            !sumario.spinnerOrderTablePrintFrom
                              ? "Guardar orden de impresión"
                              : "Guardando..."
                          }}</Button
                        >
                      </div>
                      <div test-id="addDiligenceButton">
                        <Button
                          test-id="buttomAgregarDiligencia"
                          v-if="
                            (isOnlineActuacion() || !$offline.onlineMode) &&
                            sumario.sumarioEstado != 'Finalizada' &&
                            user?.userdata?.claseDeUsuario != 'UsuarioJuzgado'
                          "
                          @click="goToAgregarDiligencia"
                          class="mt-buttons"
                          >Agregar diligencia</Button
                        >
                      </div>
                    </div>
                  </template>
                  <template #empty> Aún no contruyes diligencias. </template>
                  <template #loading> Cargando datos. </template>
                  <Column field="doc.tipo" header="Tipo">
                    <template #body="slotProps">
                      {{ slotProps.data.Nombre }}
                      <div v-if="slotProps.data.file" style="overflow-wrap: break-word">
                        {{ slotProps.data.Filename }}
                      </div>
                    </template>
                  </Column>
                  <Column field="doc.creado" header="Fecha">
                    <template #body="slotProps">
                      {{ slotProps.data.Fechainivig || fechaCreacion(slotProps.data.FechaCreacion) }}
                    </template>
                  </Column>
                  <Column field="doc.creado" header="Propietario de la diligencia">
                    <template #body="slotProps">
                      {{ apellidoNombre(slotProps.data.ApellidoP, slotProps.data.NombreP) }}
                    </template>
                  </Column>
                  <Column field="doc.creado" header="Tipo de Usuario">
                    <template #body="slotProps">
                      {{ slotProps.data.TipoUsuario }}
                    </template>
                  </Column>
                  <Column field="doc.creado" header="Dependencia">
                    <template #body=" { data }">
                      {{ data.DependenciaLetra || sumario.dependenciaPolicial }}
                    </template>
                  </Column>
                  <Column
                    headerStyle="width: 5em; text-align: right;"
                    bodyStyle="padding-right:8px; text-align: right; "
                  >
                    <template #header>
                    </template>
                    <template
                      #body="slotProps"
                      class="flex flex-column md:flex-row"
                      style="background-color: blue; text-align: right"
                    >
                      <div class="flex-reverse" style="text-align: right; display: flex">
                        <CustomButton
                          v-if="!slotProps.data.file && determineActionButtonsVisibility(slotProps)"
                          icon="pi pi-eye"
                          button-color="primary"
                          tooltipText="Ver esta diligencia"
                          @click="seeDiligencia(slotProps.data.DiligenciaID)"
                        />
                        <Button
                          v-if="
                            determineEmailButtonVisibility(slotProps.data) &&
                            indexEmailButtonDisabled !== slotProps.index
                          "
                          type="button"
                          v-tooltip.left="'Enviar email a la dependencia'"
                          icon="pi pi-envelope"
                          class="mr-2"
                          @click="
                            () => {
                              (emailBody = 'emailFileHtml'), sendAllMails(slotProps);
                            }
                          "
                        ></Button>
                        <ProgressSpinner
                          v-if="indexEmailButtonDisabled == slotProps.index"
                          style="width: 40px; height: 40px"
                        />
                        <!-- abre archivo -->
                        <a
                          v-if="slotProps.data.file && determineActionButtonsVisibility(slotProps)"
                          :href="viewFile(slotProps.data)"
                          target="_blank"
                        >
                          <CustomButton
                            icon="pi pi-eye"
                            button-color="primary"
                            tooltipText="Ver este archivo"
                          ></CustomButton>
                        </a>
                        <CustomButton
                          v-if="
                            slotProps.data.file &&
                            authorizedUserDiligencia() &&
                            determineActionButtonsVisibility(slotProps)
                          "
                          tooltipText="Eliminar este archivo"
                          button-color="rgba(211, 47, 47, 1)"
                          icon="pi pi-trash"
                          @click="confirmDelete(slotProps.data, 'archivo')"
                          :test-id="'deleteFile' + slotProps.index"
                        ></CustomButton>
                        <!-- editar diligencia -->
                        <CustomButton
                          v-if="
                            !slotProps.data.file &&
                            authorizedUserDiligencia(slotProps.data.UsuarioID) &&
                            sumario.sumarioEstado != 'Finalizada' &&
                            determineActionButtonsVisibility(slotProps)
                          "
                          tooltipText='Editar esta diligencia'
                          button-color="rgba(250, 200, 76, 1)"
                          icon="pi pi-pencil"
                          @click="editDiligencia(slotProps.data.DiligenciaID)"
                          test-id="button-editar-diligencia"
                        ></CustomButton>

                        <!-- eliminar diligencia -->
                        <CustomButton
                          v-if="
                            isOnlineActuacion() &&
                            !slotProps.data.file &&
                            authorizedUserDiligencia(slotProps.data.UsuarioID) &&
                            sumario.sumarioEstado != 'Finalizada' &&
                            determineActionButtonsVisibility(slotProps)
                          "
                          test-id="butonEliminarDiligencia"
                          button-color="rgba(211, 47, 47, 1)"
                          tooltipText='Eliminar esta diligencia'
                          icon="pi pi-trash"
                          @click="confirmDelete(slotProps.data.DiligenciaID, 'diligencia')"
                        />
                      </div>
                    </template>
                  </Column>
                  <template #footer>
                    <div
                      class="flex flex-column"
                      style="align-items: flex-end; margin-right: 2.5%; gap: 5px"
                    >
                      <div>
                        Total de diligencias: {{ filesAndDiligences ? filesAndDiligences.length : 0 }}
                      </div>
                      <div>Total de archivos: {{ files ? files.length : 0 }}</div>
                    </div>
                  </template>
                </DataTable>
                <div class="flex justify-content-end mt-3">
                  <Button
                    v-if="isOnlineActuacion() && sumario.sumarioEstado == 'Vencida'"
                    type="button"
                    icon="pi pi-sun"
                    label="Activar Prorroga"
                    class="p-button-secondary mr-3"
                    @click="activarProrroga()"
                  />
                  <Button
                    test-id="buttonReestablecerInstruccion"
                    type="button"
                    label="Reestablecer Instrucción"
                    v-tooltip.left="'Reestablecer Actuacion'"
                    icon="pi pi-link"
                    class="p-button-warning mr-2"
                    v-if="
                      authorizedUserActuacion(usersAllowedToEdit) && sumario.sumarioEstado == 'Finalizada'
                    "
                    @click="changeStatusActuacion()"
                    :disabled="disabledModifyStatusActuation"
                  ></Button>
                </div>
                <div v-if="isOnlineActuacion() && user?.userdata?.claseDeUsuario != 'UsuarioJuzgado'">
                  <div class="file-title">
                    <b>Adjuntar archivo/s</b>
                  </div>
                  <div>
                    <CustomFileUpload
                      ref="FileUpload"
                      @parentUpdateFiles="(event, clear) => updateFiles(event, clear)"
                      @parentMyUploader="myUploader"
                      @parentRemoveFiles="RemoveFiles"
                      d="userfile[]"
                      invalidFileSizeMessage="{0}: tamaño no válido, el archivo no debe pesar más de {1}."
                      accept=".jpg, .jpeg, .pdf, .png"
                      :auto="true"
                      :customUpload="true"
                      @uploader="updateFiles"
                      :maxFileSize="15000000"
                      :multiple="true"
                      uploadLabel="Adjuntar"
                      chooseLabel="Examinar archivos"
                      class="p-button-sm"
                    >

                    </CustomFileUpload>
                  </div>
                  <p
                    v-if="err"
                    style="color: #dc3545; margin-top: 20px; font-weight: 550"
                    class="ml-1 negative-mt"
                  >
                    {{ this.err }}
                  </p>
                </div>

            </div>
          </TabPanel>
          <TabPanel header="Fecha Hora y Ubicación">
            <div class="w-full flex justify-content-between align-items-center">
              <h2>Fecha, Hora y Ubicación</h2>
                <SplitButton
                  v-if="getItems().length"
                  label="Acciones"
                  :model="getItems()"
                  class="p-button-raised "
                />
            </div>
            <div class="page">
              <div class="content">
                <FechaUbicacion modelo="sumario" @save="onSave" :formType="this.formType" :isViewMode="true" ref="FechaUbiRef" />
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Afectados">
            <div class="w-full flex justify-content-between align-items-center">
              <h2 class="m-0 pl-7">Afectados</h2>
                <SplitButton
                  v-if="getItems().length" 
                  label="Acciones"
                  :model="getItems()"
                  class="p-button-raised "
                />
            </div>
            <DenunciantesView  
              :formType="this.formType"
              :actuacionType="this.actuacionType"
              isAfectados
            />
          </TabPanel>
          <TabPanel header="Vinculados">
            <div class="w-full flex justify-content-between align-items-center">
              <h2 class="m-0 pl-7">Vinculados</h2>
                <SplitButton
                  v-if="getItems().length"
                  label="Acciones"
                  :model="getItems()"
                  class="p-button-raised "
                />
            </div>
            <DenunciantesView  
              :formType="this.formType"
              :actuacionType="this.actuacionType"
            />
          </TabPanel>
          <TabPanel header="Efectos">
            <div class="w-full flex justify-content-between align-items-center">
              <h2 class="m-0 pl-7">Efectos</h2>
                <SplitButton
                  v-if="getItems().length"
                  label="Acciones"
                  :model="getItems()"
                  class="p-button-raised "
                />
            </div>
            <EfectosForm/>
          </TabPanel>
          <TabPanel header="Personal interviniente"  v-if="mostrarPersonalInterviniente">
            <div class="w-full flex justify-content-between align-items-center" >
              <h2 class="m-0 pl-7">Personal Interviniente</h2>
                <SplitButton
                  v-if="getItems().length"
                  label="Acciones"
                  :model="getItems()"
                  class="p-button-raised "
                />
            </div>
            <FormPersonalInterviniente
                card="true"
                modelo="sumario"
                :formType="this.formType"
                test-id="cardPersonalInterviniente"
                :readOnly="true"
              />
          </TabPanel>
          <TabPanel header="Evidencias">
            <div class="w-full flex justify-content-between align-items-center" >
              <h2 class="m-0 pl-7">Evidencias</h2>
                <SplitButton
                  v-if="getItems().length"
                  label="Acciones"
                  :model="getItems()"
                  class="p-button-raised "
                />
            </div>
            <EvidenciasTab/>
          </TabPanel>
        </TabView>
      </div>
    </div>
    <ModalTemplate
      title="Confirmación de Eliminación"
      type="confirmativo"
      :message='modalRefMessage'
      :showIcon="true"
      severity="danger"
      @confirm="deleteConfirmed"
      @cancel="cancelDelete"
      ref="ModalRefDelete"
    />
    <ModalSucces
      title="¿Desea finalizar la instrucción?"
      icon="pi-question-circle"
      colorIcon="#D32F2F"
      message="Esta acción es definitiva y no podrá revertirse. Para confirmar, haga clic en Finalizar. Si desea revisar nuevamente, haga clic en Cancelar."
      :showIcon="true"
      :dismissableMask="true"
      severity="primary"
      ref="ModalRefConfirm"
    >
      <template #footer>
      <div class="w-full flex justify-content-end gap-2">
        <Button 
          label="Cancelar" 
          class="bg-transparent text-gray-900 font-medium border-600 border-round-lg w-5" 
          @click="closeModalTemplate(ModalRefConfirm)" 
        />
        <Button 
          label="Finalizar" 
          class="border-round-lg w-5" 
          @click="openModalEsclarecido()" 
        />
      </div>
    </template>
    </ModalSucces>
    <ModalSucces
      title="¿El hecho fue esclarecido?"
      icon="pi-exclamation-triangle"
      colorIcon="#FBC02D"
      message="Antes de finalizar la actuación, indique si el hecho fue esclarecido seleccionando la opción correspondiente. Si es necesario, puede brindar más detalles en la descripción."
      :showIcon="true"
      :dismissableMask="true"
      severity="primary"
      ref="ModalRefEsclarecido"
    >
      <template #footer>
        <div class="flex flex-column gap-3 mb-2">
          <div class="flex flex-column gap-2">
            <div class="flex align-items-center gap-2">
              <RadioButton inputId="esclarecidoSi" name="esclarecido" :value="true" v-model="isEsclarecido" />
              <label for="esclarecidoSi">Sí</label>
            </div>
            <div class="flex align-items-center gap-2">
              <RadioButton inputId="esclarecidoNo" name="esclarecido" :value="false" v-model="isEsclarecido" />
              <label for="esclarecidoNo">No</label>
            </div>
          </div>

          <Textarea 
            v-model="DescripcionFinalizacion"
            placeholder="Ingrese descripción."
            autoResize
            rows="3"
            class="w-full"
            maxlength="200"
          />
          <span class="w-full text-red-500 text-left" v-if="errorDescripcion">{{ errorDescripcion }}</span>
        </div>
        <div class="w-full flex justify-content-end gap-2">
          <Button 
            label="Cancelar" 
            class="bg-transparent text-gray-900 font-medium border-600 border-round-lg w-5" 
            @click="closeModalTemplate(ModalRefEsclarecido)" 
          />
          <Button 
            label="Confirmar" 
            :disabled="isEsclarecido === null || errorDescripcion"
            class="border-round-lg w-5" 
            @click="handleFinalizarActuacion()" 
          />
        </div>
      </template>
    </ModalSucces>
    <ModalTemplate
      title="Información"
      type="informativo"
      message="Debe cargar al menos 3 diligencias para finalizar la actuación"
      :showIcon="true"
      @confirm="closeModalTemplate(ModalRefInform)"
      severity="danger"
      ref="ModalRefInform"
    />
    <ModalSucces 
      title="Eliminar actuación"
      icon="pi-question-circle"
      colorIcon="#D32F2F"
      message="¿Está seguro de que desea eliminar esta actuación? Esta acción es permanente y no se podrá deshacer."
      :showIcon="true"
      :dismissableMask="true"
      severity="danger"
      :closable="false"
      ref="ModalConfirmDeleteActuacion"
    >
      <template #footer>
        <div class="w-full flex justify-content-end gap-2">
          <Button 
            label="Cancelar" 
            class="bg-transparent text-gray-900 font-medium border-600 border-round-lg w-5" 
            @click="closeModalTemplate(ModalConfirmDeleteActuacion)" 
          />
          <Button 
            label="Eliminar" 
            class="border-round-lg w-5"
            style="background: #D32F2F;" 
            @click="deleteConfirmed(true)" 
          />
        </div>
      </template>
    </ModalSucces>
    <Dialog
      header="Confirmación"
      :visible.sync="displayConfirmation"
      :containerStyle="{ width: '400px' }"
      :modal="true"
    >
      <div class="confirmation-content" test-id="modal-body">
        <i class="pi pi-question-circle mr-3" style="font-size: 4rem; color: red" />
        <span>¿Está seguro que desea enviar esta actuación a otra dependencia?</span>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeConfirmation"
          class="p-button-text"
          autofocus
          test-id="btn-no"
        />
        <Button
          label="Sí"
          icon="pi pi-check"
          @click="changeSelectorStatus"
          class="p-button-danger"
          test-id="btn-si"
        />
      </template>
    </Dialog>
    <ModalTemplate
      title="Enviar a otra dependencia"
      :modal="true"
      severity="warning"
      ref="ModalRefSendDependency"
      :buttons="[
        {
          label: 'Enviar definitivamente',
          icon: 'pi pi-send',
          class: 'p-button-success',
          disabled: isConfirmDisabled,
          command: btnEnvio
        }
      ]"
    >
      <AutoComplete
        v-model="dataDependencia"
        :suggestions="filteredDependencia"
        @complete="filterDependencia($event)"
        :dropdown="true"
        field="dependencia"
        placeholder="Dependencia"
      />
      <div v-if="isDisabled.btnEnviar">
        <div class="preloader">
          <ProgressSpinner />
        </div>
      </div>
    </ModalTemplate>
    <ModalTemplate
      title="Cambiar tipo de actuación"
      :modal="true"
      severity="warning"
      ref="ModalRefSwitchActuacion"
      type="proceso"
      @cancel="ModalRefSwitchActuacion.close()"
      :confirmDisabled="isConfirmDisabled"
      @confirm="switchActuacion()"
    >
      <Dropdown
        :options="filteredOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccione tipo de actuación"
        v-model="actuacionIDforChange"
      />
    </ModalTemplate>
    <ModalSucces
      title="Compartir actuación con otra dependencia"
      icon="pi-question-circle"
      colorIcon="#D32F2F"
      message="Ambas dependencias podrán trabajar sobre la actuación, pero el control permanecerá en su dependencia de origen."
      :showIcon="true"
      :dismissableMask="true"
      severity="primary"
      ref="ModalShareConfirm"
    >
      <template #footer>
        <div class="w-full flex justify-content-end gap-2">
          <Button 
            label="Cancelar" 
            class="bg-transparent text-gray-900 font-medium border-600 border-round-lg w-5" 
            @click="closeModalTemplate(ModalShareConfirm)" 
          />
          <Button 
            label="Compartir" 
            class="border-round-lg w-5" 
            @click="handleShareActuacion(true)" 
          />
        </div>
      </template>
    </ModalSucces>
    <ModalSucces
      title="¿Está seguro de que desea compartir esta actuación?"
      icon="pi-exclamation-triangle"
      colorIcon="#FBC02D"
      message="Seleccione la dependencia con la que desea compartir esta actuación. Ambas dependencias podrán visualizar, gestionar diligencias y consultar archivos asociados, trabajando de manera conjunta."
      :showIcon="true"
      :dismissableMask="true"
      severity="primary"
      ref="ModalRefShare"
    >
      <template #footer>
        <div class="flex w-full mb-3">
          <Dropdown
            :options="dependenciasFiltradas"
            optionLabel="label"
            optionValue="value"
            placeholder="Seleccione Dependencia"
            v-model="dependenciaForShare"
            class="w-full text-left"
          />
        </div>
        <div class="w-full flex justify-content-end gap-2">
          <Button 
            label="Cancelar" 
            class="bg-transparent text-gray-900 font-medium border-600 border-round-lg w-5" 
            @click="closeModalTemplate(ModalRefShare)" 
          />
          <Button 
            label="Aceptar" 
            class="border-round-lg w-5" 
            :disabled="!dependenciaForShare"
            @click="handleShareActuacion()" 
          />
        </div>
      </template>
    </ModalSucces>
  </div>

</template>

<script>
import CustomFileUpload from "../../components/custom-fileupload";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import BlockUI from "primevue/blockui";
import axios from "axios";
import ModalTemplate from "../../components/ModalTemplate.vue";
import generalFunctions from "../../store/modules/generalFunctions.js";
import { actuacionesConfig } from "@/router/RoutesConfig/actuacionesConfig/actuacionesConfig";
import "vue-toast-notification/dist/theme-sugar.css";
import Dropdown from "primevue/dropdown/Dropdown";
import PDFViewer from '../../components/PDF-viewer/PDFViewer.vue'
import SplitButton from "primevue/splitbutton";
import CustomButton from "@/components/custom-button/CustomButton.vue";
import DenunciantesView from "./componentsViewActuacion/DenunciantesView.vue";
import FormPersonalInterviniente from "@/components/forms/FormPersonalInterviniente.vue";
import ModalSucces from '@/components/ModalSucces'
import RadioButton from 'primevue/radiobutton';
import { defineComponent, getCurrentInstance, nextTick, onBeforeMount, onMounted, reactive, ref, watch, computed } from "vue";
import { useStoreCompat } from "@/composables/useStoreCompat";
import { useRest } from "@/composables/useRest";
import { useToast } from "@/composables/useToast";
import { useRouterCompat } from '@/composables/useRouterCompat';
import { useOfflineCompat } from '@/composables/useOfflineCompat';
import { useDialog } from "@/composables/DenunciaFormDatosGenerales/useDialog";
import { useActuations } from '@/composables/useActuaciones';
import { useProsecutor } from '@/composables/DenunciaFormDatosGenerales/useProsecutor'
import { EvidenciasTab ,EfectosForm, FechaUbicacion } from "./componentsViewActuacion/index.js";
import { useDependenciasStore } from '@/store/Pinia/useDependenciasStore'

export default defineComponent({
  name: "DenunciaFormDatosGenerales",
  components: {
    DataTable,
    Column,
    BlockUI,
    CustomFileUpload,
    ModalTemplate,
    PDFViewer,
    SplitButton,
    CustomButton,
    FechaUbicacion,
    DenunciantesView,
    FormPersonalInterviniente,
    EfectosForm,
    ModalSucces,
    RadioButton,
    EvidenciasTab,
  },
  setup(props, { emit }) {
    const store = useStoreCompat()
    const rest = useRest()
    const toast = useToast()
    const { router, route } = useRouterCompat();
    const offline = useOfflineCompat();
    const {
    getActuationsForTanstack,
    getActuationsForTanstackByPage,
    getActuationFromCache,
    saveActuationInCache,
    getGenericDataFromCache,
    saveGenericDataInCache,
    deleteGenericDataFromCached,
  } = useActuations();
    
    const dependenciasStore = useDependenciasStore()
    const { prosecutorUserTypes } = useProsecutor()

    // const dependenciaList = computed(() => store.getters["siis/getDependecias"]);
    const dependenciaList = computed(() => dependenciasStore.dependencias)
    const resumen = computed(() => store.getters['sumario/dataResumen']);
    const sumario = computed(() => store.state.sumario);
    const user = computed(() => store.state.user);
    const juzgadosListFromDB = computed(() => store.state.siis.juzgados);
    const articulosList = computed(() => store.state.siis.articulos);
    const causasList = computed(() => store.state.siis.causaCaratula);
    const delitoList = computed(() => store.state.siis.delitos);
    const numeroUfiList = computed(() => store.state.siis.ufis);
    const ayudanteFiscal = computed(() => store.state.siis.assistants);
    const fiscal = computed(() => store.state.siis.prosecutors);
    const viewData = computed(() => store.state.sumarioViews);
    const formType = computed(() => store.state.sumario.formType);
    const modusoperandiList = computed(() => store.state.siis.modusoperandi);
    const sitio = computed(() => store.state.siis.sitio);
    const sitioResumen = computed(() => resumen.value?.Sitio || 'Sin Sitio');
    const dependencyOwn = computed(() => user.value.userdata.tipoUsuario);
    const juzgadoResumen = computed(() => {
      return sumario.value?.causaJuzgado?.length === 0
        ? resumen.value.dependencia
        : resumen.value?.juzgado;
    });
    const ufiResumen = computed(() => {
      return typeof resumen.value.ActuacionUfi === 'undefined'
        ? 'Sin N° Ufi asignado'
        : resumen.value.ActuacionUfi;
    });

    const fiscalResumen = computed(() => {
      return typeof resumen.value.prosecutor === 'undefined'
        ? 'Sin Fiscal asignado'
        : resumen.value.prosecutor;
    });

    const assistantResumen = computed(() => {
      return typeof resumen.value.assistant === 'undefined'
        ? 'Sin Ayudante asignado'
        : resumen.value.assistant;
    });

    const yearResumen = computed(() => {
      return new Date(resumen.value.fechaCertificadoDenuncia).getFullYear();
    });

    const juzgadosList = computed(() => {
      if (sumario.value.formType?.includes('Preliminar')) {
        return [
          { Nombre: resumen.value.dependencia },
          ...juzgadosListFromDB.value
        ];
      }
      return juzgadosListFromDB.value;
    });

    const legajoNroResumen = computed(() => {
      return sumario.value.causaNumero || sumario.value.Numero;
    });

    const mostrarPersonalInterviniente = computed(() => {
      const tipoSumario = sumario.value?.formType || sumario.value?.tiposumarioID;
      const tiposPermitidos = [
        'Sumario Prevencional Por Oficio',
        'Expediente Contravencional por oficio',
        'Unidades Fiscales de Investigación Delitos Genéricos por Oficio',
        'Unidades Fiscales de Investigacion ANIVI',
        'Unidades Fiscales de Investigacion Flagrancia',
        'Unidades Fiscales de Investigación Delitos Contra la Propiedad por Oficio',
        'Unidades Fiscales de Investigacion CAVIG',
        'Unidades Fiscales de Investigación Delitos Informáticos y Estafas por Oficio',
        'Unidades Fiscales de Investigacion D.E Emergencias Medicas',
        'Unidades Fiscales de Investigacion D.E Siniestro Vial',
        'Unidades Fiscales de Investigacion D.E Ahorcamiento o Suicidio',
        'Unidades Fiscales de Investigacion D.E Incendio en Vivienda',
        'Unidades Fiscales de Investigacion D.E Intoxicacion',
        'Actuacion Preliminar por Incendio en Vivienda',
        'Actuacion Preliminar para Establecer Procedencias',
        'Actuacion Preliminar por Fuga de Menor',
        'Actuacion Preliminar por Siniestro Vial',
        'Actuacion Preliminar por Caida Casual',
        'Actuacion Preliminar por Incendio de Automotor',
        'Actuacion Preliminar por Tentativa de Suicidio',
        'Actuacion Preliminar - Otros',
      ];
      return tiposPermitidos.includes(tipoSumario);
    });

    const currentDate = computed(() => {
      const current = new Date();
      const options = { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' };
      const parts = current.toLocaleDateString('es-ES', options).split(' de ');
      return `${parts[0]} de ${parts[1]} del ${parts[2]}`;
    });

    const emailFileHtml = computed(() => {
      return `
        <p>${dependencyOwn.value}, ${currentDate.value}</p>
        <h1>${sumario.value.tiposumarioID}</h1>
        <p>S/D</p>
        <p>Objeto: R/ Informe Técnico</p>
        <p>
          Me dirijo a Ud. a fin de informar en relación a lo solicitado por el Sr. Jefe de
          ${resumen.value.dependencia}, en nota OFICIO LEGAJO Nº ${sumario.value.causaNumero}
        </p>
        <p>Dando cumplimiento a lo solicitado.</p>
      `;
    });

    const emailEvidenceHtml = computed(() => {
      return `
        <p>${dependencyOwn.value}, ${currentDate.value}</p>
        <h1>${sumario.value.tiposumarioID}</h1>
        <p>S/D</p>
        <p>Objeto: R/ Informe Técnico</p>
        <p>
          Me dirijo a Ud. a fin de informar en relación a lo solicitado por el Sr. Jefe de
          ${resumen.value.dependencia}, en nota OFICIO LEGAJO Nº ${sumario.value.causaNumero}
        </p>
        <p>
          A continuación podrá acceder a la evidencia: <a href='${proxy.evidence}'> ${proxy.evidence}</a>
        </p>
        <p>Dando cumplimiento a lo solicitado.</p>
      `;
    });

    const acusadosTodosResumen = computed({
      get: () => {
        return store.getters["sumario/acusados/acusadosTodosResumen"];
      }
    })

    const dataArticulos = computed({
      get: () => '',
      set: (value) => {
        const el = modalUpdateRef.value?.$el?.getElementsByClassName("p-dialog-content")[0];
        if (el?.offsetHeight >= 326) {
          el.style.overflow = "auto";
        }
        if (value !== null && value !== undefined && !articulos.value.includes(value)) {
          articulos.value = [...articulos.value, value];
        }
      }
    });

    const dataCaratulas = computed({
      get: () => '',
      set: (value) => {
        const el = modalUpdateRef.value?.$el?.getElementsByClassName("p-dialog-content")[0];
        if (el?.offsetHeight >= 326) {
          el.style.overflow = "auto";
        }
        if (value !== null && value !== undefined && !listaCaratulas.value.includes(value)) {
          listaCaratulas.value = [...listaCaratulas.value, value];
        }
      }
    });

    const dataCrimes = computed({
      get: () => '',
      set: (value) => {
        const el = modalUpdateRef.value?.$el?.getElementsByClassName("p-dialog-content")[0];
        if (el?.offsetHeight >= 326) {
          el.style.overflow = "auto";
        }
        if (value !== null && value !== undefined && !crimes.value.includes(value)) {
          crimes.value = [...crimes.value, value];
        }
      }
    });

    const translateNameFromFormType = computed(() => generalFunctions.translateNameFromFormType);

    const usersAllowedToEdit = computed(() => {
      let usersAllowed = ["Super User", "SecretarioActual", "Jefe de Sumario", "Jefe de Dependencia"];
      usersAllowed = usersAllowed.concat(prosecutorUserTypes);
      return usersAllowed;
    });

    const isForensicOrCriminology = computed(() => {
      const tipo = user.value.userdata.tipoUsuario;
      return (
        tipo === "Dpto.Criminalistica" ||
        tipo === "Lab. Informatico Forense" ||
        tipo === "Super User"
      );
    });

    const filteredOptions = computed(() => {
      const allOptions = [
        { name: "Unidades Fiscales de Investigación Delitos Contra la Propiedad por Denuncia" },
        { name: "Unidades Fiscales de Investigación Delitos Genéricos por Denuncia" },
        { name: "Unidades Fiscales de Investigacion Flagrancia" },
        { name: "Unidades Fiscales de Investigación Delitos Genéricos por Oficio" },
        { name: "Unidades Fiscales de Investigación Delitos Contra la Propiedad por Oficio" }
      ];

      const group = {
        group1: [
          "Unidades Fiscales de Investigación Delitos Contra la Propiedad por Denuncia",
          "Unidades Fiscales de Investigación Delitos Genéricos por Denuncia"
        ],
        group2: [
          "Unidades Fiscales de Investigacion Flagrancia",
          "Unidades Fiscales de Investigación Delitos Genéricos por Oficio",
          "Unidades Fiscales de Investigación Delitos Contra la Propiedad por Oficio"
        ]
      };

      const currentType = resumen.value?.formType || "";

      const allowedOptions = Object.values(group)
        .find(group => group.includes(currentType))
        ?.filter(option => option !== currentType) || [];

      return allOptions
        .filter(option => allowedOptions.includes(option.name))
        .map(option => ({
          label: proxy.formatNameUFI(option.name),
          value: option.name
        }));
    });

    const dataDependencia = computed({
      get: () => dependencia.value,
      set: (val) => (dependencia.value = val),
    });

    const modalUpdateRef = ref(null);
    const nroActuacion = ref('');

    const showMo = () => {
      if (sumario.value?.formType == null || sumario.value?.formType == undefined) {
        toast.error("ERROR: No se pudo identificar el tipo de esta actuación");
      }
      if (sumario.value.formType.includes("contravencional")) {
        return false;
      } else if (sumario.value.formType.includes("Contravencional")) {
        return false;
      } else return true;
    }

    const caratulasResumen = computed(() => {
      if (sumario.value?.listaArticulos?.length) {
        arrayArticulos.value = formatArticulos();
        return arrayArticulos.value.join(', ');
      }
      arrayCausaCaratula.value = formatCausasCaratulas();
      if (resumen.value.caratula || resumen.value.listaCaratulas) {
        return resumen.value.listaCaratulas || resumen.value.caratula;
      } else {
        return 'Sin Causa/Carátula asignada';
      }
    });

    const dependenciasFiltradas = computed(() => {
      return dependenciaList.value
        .filter(dep => dep.dependencia.toLowerCase().includes('brigada'))
        .map(dep => ({
          label: dep.dependencia,
          value: dep.id
        }))
    })

    const fileData = ref(null)
    const itemTypeToDelete = ref(null)
    const modalRefMessage = ref('')
    const anios = ref([
      { anio: new Date().getFullYear(), code: JSON.stringify(new Date().getFullYear()).slice(-2) },
      { anio: new Date().getFullYear() - 1, code: JSON.stringify(new Date().getFullYear() - 1).slice(-2) }
    ])
    const indexEmailButtonDisabled = ref(null);
    const selectedDropdownValue = ref(null);
    const disabledModifyStatusActuation = ref(false);
    const dangerClass = ref(false);
    const iconModal = ref({});
    const buttomAceptar = ref({ buttom: true, action: true });
    const buttomCancelar = ref({ buttom: true, action: false });
    const msjEnable = ref(false);
    const mensaje = ref('');
    const formData = ref(null);
    const response = ref(null);
    const err = ref(false);
    const files = ref(null);
    const filesAndDiligences = ref([]);
    const filesAndDiligencesByDate = ref([]);
    const loading = ref(false);
    const causaJuzgado = ref('');
    const articulos = ref([]);
    const causaCaratula = ref('');
    const dependencia = ref('');
    const listaCaratulas = ref([]);
    const filteredDependencia = ref([]);
    const selectorDisabled = ref(true);
    const displayConfirmation = ref(false);
    const displayModal = ref(false);
    const headerModal = ref('');
    const ufiInterviniente = ref('');
    const assistants = ref('');
    const prosecutor = ref('');
    const sumarioEstado = ref('');
    const aceptarLabel = ref(undefined);
    const cancelarLabel = ref(undefined);
    const ClickAceptar = ref(() => {});
    const crimes = ref([]);
    const evidence = ref('');
    const emailBody = ref('');
    const arrayCausaCaratula = ref([]);
    const arrayArticulos = ref([]);
    const actuacionIDforChange = ref('');
    const isConfirmDisabled = ref(false);
    const DescripcionFinalizacion = ref('');
    const errorDescripcion = ref(null)
    const isEsclarecido = ref(null);
    const actuacionType = ref(null)
    const tabIndex = ref(0)

    const orderBy = ref({ id: 1, nombre: "Fecha" });
    const isDisabled = reactive({ btnEnviar: false });
    const orderList = ref([
      { id: 1, nombre: "Fecha" },
      { id: 2, nombre: "Impresión" }
    ]);
    const filteredOrder = ref([])
    const FechaUbiRef  = ref(null)
    const FileUpload = ref(null)
    const ModalRefEsclarecido = ref(null)
    const ModalRefConfirm = ref(null)
    const ModalRefInform = ref(null)
    const ModalRefSwitchActuacion = ref(null)
    const ModalRefDelete = ref(null)
    const ModalRefSendDependency = ref(null)
    const ModalDropdown = ref(null);
    const ModalInputText = ref(null);
    const ModalRefShare = ref(null);
    const ModalConfirmDeleteActuacion = ref(null)
    const dependenciaForShare = ref(null)
    const ModalShareConfirm = ref(null)
    

    const {
      modalAttributes,
      confirmationMode,
      modalSpinner,
      allowEmptySave,
      blankArray,
      saveModalData,
      isSaveDisabled,
      openModal,
      closeModal,
      formatCausasCaratulas,
      loadModalAttributes,
      evaluateIfFormTypeIsUFI,
      formatArticulos,
      changeModal,
      deleteModalItem,
      getIcon,
      getIconColor
    } = useDialog({
      causaJuzgado,
      causaCaratula,
      crimes,
      listaCaratulas,
      articulos,
      nroActuacion,
      ufiInterviniente,
      assistants,
      prosecutor,
      sumario,
      displayModal,
      selectedDropdownValue,
      delitoList,
      resumen,
      causasList,
      showMo,
      articulosList,
      juzgadosList,
      numeroUfiList,
      ayudanteFiscal,
      fiscal,
      refs:{
        causaJuzgado,
        causaCaratula,
        crimes,
        listaCaratulas,
        articulos,
        nroActuacion,
        ufiInterviniente,
        assistants,
        prosecutor,
        ModalDropdown,
        ModalInputText,
        modalUpdateRef,
        dataCrimes,
        dataCaratulas,
        dataArticulos,
      },
      modalUpdateRef,
      nroActuacion,
    })

    const datosCargados = computed(() => {
      return !!sumario.value?.id && resumen.value?.formulario;
    });

    const permisosPorUsuario = {
      //UserAdmin
      "Usuario Admin": [
        "Editar Actuacion",
        "Cambiar tipo de actuación",
        "Enviar a otra dependencia",
        "Finalizar instrucción",
        "Eliminar Actuacion",
        "Compartir Actuación",
      ],
      "Super User": [
        "Editar Actuacion",
        "Cambiar tipo de actuación",
        "Enviar a otra dependencia",
        "Finalizar instrucción",
        "Eliminar Actuacion",
        "Compartir Actuación",
      ],
      "User Tester": [
        "Editar Actuacion",
        "Cambiar tipo de actuación",
        "Enviar a otra dependencia",
        "Finalizar instrucción",
        "Eliminar Actuacion",
        "Compartir Actuación",
      ],
      //UserDependencia
      "Jefe de Sumario": [
        "Editar Actuacion",
        "Cambiar tipo de actuación",
        "Enviar a otra dependencia",
        "Finalizar instrucción",
        "Eliminar Actuacion",
        "Compartir Actuación",
      ],
      "Jefe de Dependencia": [
        "Editar Actuacion",
        "Cambiar tipo de actuación",
        "Enviar a otra dependencia",
        "Finalizar instrucción",
        "Eliminar Actuacion",
        "Compartir Actuación",
      ],
       //oficial Sumariante
       "Oficial Sumariante": [
        "Editar Actuacion",
        "Cambiar tipo de actuación",
        "Enviar a otra dependencia",
        "Finalizar instrucción",
        "Compartir Actuación",
      ],

      //UserFiscal
      "Fiscal General": [
        "Editar Actuacion",
        "Finalizar Actuacion",
      ],
      Supervisor: [
        "Editar Actuacion",
        "Finalizar Actuacion",
      ],
      "Ayudante Fiscal": [
        "Editar Actuacion",
        "Finalizar Actuacion",
      ],
      UsuarioFiscal: [
        "Editar Actuacion",
        "Finalizar Actuacion",
      ],
      Fiscal: [
        "Editar Actuacion",
        "Finalizar Actuacion",
      ],
      Administrativo: [
        "Editar Actuacion",
        "Finalizar Actuacion",
      ],
      "Policia Investigador": [
        "Editar Actuacion",
        "Finalizar Actuacion",
      ],
    }

    const acciones = {
      "Editar Actuacion": {
        label: "Editar Actuacion",
        icon: "pi pi-pencil",
        command: () => {
          editarActuacion();
        },
      },
      "Cambiar tipo de actuación": {
        label: "Cambiar tipo de actuación",
        icon: "pi pi-sync",
        command: () => {
          openModalTemplate(ModalRefSwitchActuacion);
        },
      },
      "Enviar a otra dependencia": {
        label: "Enviar a otra dependencia",
        icon: "pi pi-sign-out",
        command: () => {
          openModalTemplate(ModalRefSendDependency)
        },
      },
      "Finalizar instrucción": {
        label: "Finalizar instrucción",
        icon: "pi pi-times-circle",
        command: () => {
          verifyAmountOfDiligences('ModalRefConfirm');
        },
      },
      "Eliminar Actuacion": {
        label: "Eliminar Actuacion",
        icon: "pi pi-trash",
        command: () => {
          openModalTemplate(ModalConfirmDeleteActuacion);
        },
      },
      "Compartir Actuación": {
        label: "Compartir Actuación",
        icon: "pi pi-link",
        command: () => {
          openModalTemplate(ModalRefShare)
        },
      },
    }

    onBeforeMount(async () => {
      store.dispatch('sumario/resetState');
      
      let { id } = route.params;
      loading.value = true;
      id = id.includes("toUpdate") ? id.replace("toUpdate", "") : id;
      // esto genera Maximun stack overflow -> es tanStack
      // let cachedActuation = await getActuationFromCache(id);
      // if (await cachedActuation !== undefined) {
      //   await store.dispatch("sumario/setSumario", { siis_state: cachedActuation });
      //   await setDiligencias(cachedActuation.diligencia);
      // }
      setTimeout(async () => {
        // if (await cachedActuation === undefined) {
          await store.dispatch("sumario/setSumario", id);
          await setDiligencias();
          await saveActuationInCache(id, sumario);
        // }
        await filesQuery(id);
        sortByDate();
        loading.value = false;
      }, 100);
      // await store.dispatch("siis/setDependencias");
      await dependenciasStore.setDependencias()
      store.dispatch('siis/setModusoperandi');
      await store.dispatch('siis/setSitio')
      store.dispatch("siis/setArticulos");
      store.dispatch("siis/setJuzgados");
      store.dispatch("siis/setCausaCaratula");
      store.dispatch("siis/setDelitos");
      store.dispatch("siis/setUFIs");
      store.dispatch("siis/setCausaCaratula");
      store.dispatch("siis/setProsecutorOrAssistant", { en: "prosecutors", es: "fiscal" });
      store.dispatch("siis/setProsecutorOrAssistant", { en: "assistants", es: "ayudante" });
    });

    onMounted(() => {
      getDefaultEvidence();
      handleDiligenciaLoaded()
      const scrollY = parseInt(route.query.scrollY || '0');
      const tabIndexQuery = parseInt(route.query.tabIndex || '0');
      // tabIndex.value = tabIndexQuery
      if(scrollY){
        nextTick(() => {
          nextTick(() => {
            tabIndex.value = tabIndexQuery;
            window.scrollTo(0, scrollY);
          });
        });
      }

      // ↓ Descomentar esta línea para habilitar Tanstack
      // await getActuationsForTanstack();
    })

    const onTabChange = (event) => {
      if(route.query.scrollY){
        router.replace({
          path: route.path,
          query: {}
        });
      }
      tabIndex.value = event.index
      if (event.index === 2) { 
        nextTick(() => {
          setTimeout(() => {
            FechaUbiRef.value?.$refs?.map?.refreshMap();
          }, 300);
        });
      }
    }

    const formatNameUFI = (name) => {
      const regex = /^Unidades Fiscales de Investigaci[oó]n/i;
      if (regex.test(name)) {
        return `UFI ${name.replace(regex, "").trim()}`;
      }
      return name;
    }

    const handleDiligenciaLoaded = (isLoaded) => {
      if (isLoaded) {
        const iframe = document.getElementById("denunciaPrint").querySelector("iframe");
        iframe.addEventListener("load", () => {
          nextTick(() => {
            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
            const contentHeight = Math.max(
              iframeDoc.body.scrollHeight,
              iframeDoc.documentElement.scrollHeight,
              iframeDoc.body.offsetHeight,
              iframeDoc.documentElement.offsetHeight,
              iframeDoc.body.clientHeight,
              iframeDoc.documentElement.clientHeight
            );
            const heightThreshold = 10;
            if (contentHeight > heightThreshold) {
              isDiligenciaView.value = true; // Cambia el estado para ocultar el loader
            }
          });
        });
      }
    }

    const activarProrroga = () => {
      mensaje.value = "Está seguro desea activar la prórroga por 5 Días?";
      buttomAceptar.value = { buttom: true, action: true };
      buttomCancelar.value = { buttom: true, action: false };
      aceptarLabel.value = "si";
      cancelarLabel.value = "no";
      ClickAceptar.value = () => {
        msjEnable.value = false;
        mensaje.value = "";
        updateStateActuacion(true);
        aceptarLabel.value = undefined;
        cancelarLabel.value = undefined;
      };
      msjEnable.value = true;
    }

    const secretarioOriginalString = computed(() => {
      const actuacion = sumario.value?.diligencia;
      let apellido = '';
      let nombre = '';

      if (Array.isArray(actuacion) && actuacion.length > 0) {
        apellido = actuacion[0]?.ApellidoP || '';
        nombre = actuacion[0]?.NombreP || '';
      } else {
        apellido = user.value?.userdata?.apellido || '';
        nombre = user.value?.userdata?.nombre || '';
      }

      const result = [apellido, nombre].filter(Boolean).join(', ');
      return result || 'Nombre desconocido';
    });

    const secretarioActualString = computed(() => {
      const actuacion = sumario.value?.ActuacionUsuarioDependencia;

      if (!actuacion) {
        return `${user.value.userdata.apellido}, ${user.value.userdata.nombre}`;
      }

      const actual = actuacion.find((e) => e.Fechahasta === null);

      if (!actual) {
        dangerClass.value = true;
        return "Los datos de la Persona asociados a este Usuario fueron borrados";
      }

      if (actual.Apellido !== "Persona de Filiacion desconocida") {
        return `${actual.Apellido}, ${actual.Nombre}`;
      } else {
        dangerClass.value = true;
        return "NO está asignado ningun secretario";
      }
    });

    const isOnlineActuacion = () => {
      return offline.onlineMode && sumario.value.id?.search("offline-") != 0;
    }

    const changeStatusActuacion = () => {
      iconModal.value = {}; // indicamos que no queremos icono en este modal
      buttomAceptar.value = { buttom: true, action: true };
      buttomCancelar.value = { buttom: true, action: false }; // habilitamos boton para cancelar
      ClickAceptar.value = () => {
        msjEnable.value = false;
        mensaje.value = "";
        buttomAceptar.value = { buttom: true, action: false };
        buttomCancelar.value = { buttom: false, action: false };
        updateStateActuacion();
        disabledModifyStatusActuation.value = true;
      };
      mensaje.value =
        sumario.value.sumarioEstado != "Finalizada"
          ? "Seguro que desea dar por Finalizada la Actuacion ?"
          : "Si Reestablece esta Actuacion, la misma volvera a estar 'En Curso' o 'Vencida' segun corresponda, seguro desea continuar?";
      msjEnable.value = true;
    }

    const updateStateActuacion = async (activarProrroga = false) => {
      loading.value = true;
      let newEstadoActuacion;
      if (sumario.value.sumarioEstado == "Finalizada" || activarProrroga) {
        newEstadoActuacion = "En Curso";
      } else {
        newEstadoActuacion = "Finalizada";
      }
      let data = {
        ActuacionID: sumario.value.ActuacionID,
        //Si el estado actual es distinto a Finalizada, entonces el Usuario esta finalizando la Actuacion (solo tenemos esa opcion al dia 08-06-2022)
        NuevoEstado: newEstadoActuacion,
        Esclarecido: false,
      };
      try {
        let request = await axios.put(
          `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/estado-actuacion/${sumario.value.id}`,
          data,
          { withCredentials: true, params: { method: "own" } }
        );
        if (request.data.error === "") {
          let iconModal = {
            type: "pi pi-check-circle",
            style: "font-size: 3em; color: rgb(89, 150, 29);",
          };
          if (activarProrroga) {
            finalizarCambioEstado(
              "Se activó la prórroga con éxito",
              iconModal,
              true,
              false,
              route.fullPath
            );
          } else {
            let mensaje =
              sumario.value.sumarioEstado != "Finalizada"
                ? "La Actuacion Se Finalizo con Exito"
                : "La Actuacion Se reestablecion con Exito";
            finalizarCambioEstado(mensaje, iconModal, true, false, "/sumario");
          }
        }
      } catch (e) {
        let iconModal = { type: "pi pi-exclamation-circle", style: "font-size: 3em; color: red;" };
        if (activarProrroga) {
          finalizarCambioEstado("No se pudo activar la prórroga", iconModal, true);
        } else {
          let mensaje =
            sumario.value.sumarioEstado != "Finalizada"
              ? "La Actuacion No se pudo Finalizar"
              : "La Actuacion no pudo Reestablecerse";
          finalizarCambioEstado(mensaje, iconModal, true, true);
        }
      }
      loading.value = false;
    }
    const finalizarCambioEstado = (msg, icon, mensajeEnable = false, error = false, routerPush) => {
      aceptarLabel.value = undefined;
      cancelarLabel.value = undefined;
      buttomCancelar.value = { buttom: false, action: false };
      buttomAceptar.value = { buttom: true, action: false, routerPush };
      iconModal.value = icon;
      err.value = error;
      mensaje.value = msg;
      msjEnable.value = mensajeEnable;
    }
    const colorActive = () => {
      switch (sumario.value.sumarioEstado) {
        case "En Curso":
          return "success";
        case "Vencida":
          return "warning";
        case "Finalizada":
          return "danger";
      }
    }
    const deleteFile = async (file) => {
      const id = file.ActuacionArchivoID;
      let optionsDelete = {
        url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/files/sumario/${id}`,
      };
      try {
        loading.value = true;
        await rest.del(optionsDelete);
        await deleteGenericDataFromCached('files ' + sumario.id);
        await filesQuery();
        RemoveFiles();
      } catch (e) {
        console.error(e);
        loading.value = false;
      }
      sortByDate();
    }

    const setDiligencias = async (diligencesFromCache) => {
      let diligences = diligencesFromCache !== undefined ? diligencesFromCache : sumario.value.diligencia;
      filesAndDiligences.value = Array.isArray(diligences)
        ? diligences
        : []; 
    }

    const fechaCreacion = (fecha) => {
      let fechaAux = new Date(fecha); //la fecha viene en formato string por eso la convertimos
      let fechaCambioHorarioBd = new Date("2022-04-08 19:00:45"); //esta es la fecha y hora a partir de la cual se actualizo la zona horaria de la Api
      if (fechaAux < fechaCambioHorarioBd) {
        let fechaYhoraAux = fechaAux.getTime() - 180 * 60000; //le restamos 3 horas, por que la mayoria de ellas, se guardaron con 3 horas +, ya que en argentina estamos -3
        let FechayHoraCreacion = new Date(fechaYhoraAux); //volvemos a formato fecha

        let fechaCreacion = FechayHoraCreacion.toLocaleDateString("es-AR"); //extraemos la fecha
        let horaCreacion = FechayHoraCreacion.toLocaleTimeString("es-AR"); //extraemos la hora

        return fechaCreacion + " " + horaCreacion;
      } else {
        let fechaCreacion = fechaAux.toLocaleDateString("es-AR"); //extraemos la fecha
        let horaCreacion = fechaAux.toLocaleTimeString("es-AR"); //extraemos la hora
        return fechaCreacion + " " + horaCreacion;
      }
    }

    const deleteActuacion = async () => {
      closeModalTemplate(ModalConfirmDeleteActuacion)
      loading.value = true;
      try {
        store.dispatch("sumarioList/loadingUpdate", true);
        let resp = await store.dispatch("sumario/deleteActuacion", sumario.value.id);
        if (resp == true) {
          await store.dispatch("sumarioList/deleteActuaciones", sumario.value.id);
          await store.dispatch("sumarioList/resetActuaciones");
          toast.success("La actuación fue eliminada correctamente");
        }
        loading.value = false;
      } catch (error) {
        console.error(error)
      }finally{
        router.push({ path: `/actuaciones/list` });
      }
    }

    const changeSelectorStatus = () => {
      selectorDisabled.value = false;
      displayConfirmation.value = false;
    }

    const btnEnvio = async () => {
       if (!sumario.value?.actuacionUsuarioDependenciaID) {
          toast.error("No se encontró información válida de la actuación actual para continuar con el envío.");
          return;
        }
        isConfirmDisabled.value = true;
        let datos = {
          UpdatePrevious: { DependenciaID: sumario.value.DependenciaID }, //enviamos los datos nescesarios para actualizar el registro anterior(en este caso solo nescesita el Id de la dependencia actual del sumario)
          LoadNew: {
            DependenciaID: dependencia.value.id,
            Numeroextracto: sumario.value.causaNumero
              ? sumario.value.causaNumero
              : sumario.value.ActuacionUsuarioDependencia.find((e) => e.Fechahasta === null).Numeroextracto,
          }, //enviamos el Id de la nueva Dependencia
        };
        isDisabled.btnEnviar = true;
        try {
          let request = await axios.post(
            `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/actuacion-usuario-dependencia/${sumario.value.actuacionUsuarioDependenciaID}`,
            datos,
            { withCredentials: true, params: { method: "own" } }
          );
          await store.dispatch("sumarioList/get", { accion: "inicio" });
  
          if (request.data.error === "" && request.status === 200) {
            router.push({ path: `/actuaciones/list` });
            toast.success("La actuación fue enviada correctamente a la dependencia.");
          }
        } catch (error) {
          console.error(error);
          toast.error("Ocurrió un error al intentar enviar la actuación. Intente nuevamente o contacte al administrador.");
        }
    }

    const openConfirmation = () => {
      displayConfirmation.value = true;
    }
    const closeConfirmation = () => {
      displayConfirmation.value = false;
    }
    const goToAddDiligencia = () => {
      // $router.push('/sumario/denuncia/detalle/'+sumario.SumarioID+'/addDiligencia')
    }
    //El siguiente metodo habilita los botones relacionados a la actuacion
    const authorizedUserActuacion = (aplicaSobre = []) => {
      let tiposUserAutorizados = aplicaSobre;
      let propietario = false;
      if (aplicaSobre.includes("SecretarioActual")) {
        //si el usuario logeado es el secretario actual de la actuacion entonces le permitimos editar/elimar
        propietario = sumario.value?.ActuacionUsuarioDependencia?.find((e) => {
          if (e.NombreUsuario == user.value.userdata.usuarioNombre && e.Fechahasta == null) {
            return true;
          }
        });
      }
      if (aplicaSobre.includes("Super User")) {
        // en caso de ser algo que solo los Super Usuarios puedan ver
        tiposUserAutorizados.push("Super Usuario de E3", "Super User", "User Tester");
      }
      if (propietario || tiposUserAutorizados.includes(user.value.userdata.tipoUsuario)) {
        return true;
      } else {
        return false;
      }
    }
    //El siguiente metodo habilita los botones relacionados a las diligencias
    const authorizedUserDiligencia = (diligenciaID = null) => {
      let propietario = diligenciaID == user.value.uid ? true : false;
      //si el usuario es el SuperUserE3 que pueda verlos
      //Y si es un Jefe de sumario tambien puede Editar/eliminar
      if (
        propietario ||
        user.value.userdata.usuarioNombre == "SuperUserE3" ||
        user.value.userdata.claseDeUsuario == "UsuarioFiscal" ||
        user.value.userdata.permisos.find(
          (element) =>
            element.TipoUsuarioID == "TipoUsuarioJefeDeSumario" ||
            element.TipoUsuarioID == "UserTester" ||
            element.TipoUsuarioID == "SuperUser"
        ) != undefined
      ) {
        return true;
      } else {
        return false;
      }
    }
    
    const apellidoNombre = (apellido, nombre) => {
      var respuesta = "";
      //apellido y nombre pueden venir de realizar un "concat" en sumario.js, lo que implica que null puede ser tomado como un string
      respuesta =
        apellido == "null" || apellido == null || apellido == "Sin Apellido Especificado"
          ? ""
          : apellido;
      respuesta =
        nombre == "null" || nombre == null || nombre == "Sin Apellido Especificado"
          ? respuesta
          : respuesta == ""
            ? nombre
            : respuesta + " ," + nombre;
      return respuesta;
    }

    const deleteDiligencia = async (diligenciaId) => {
      loading.value = true;
      let resp = await store.dispatch("sumario/deleteDiligencia", diligenciaId);
      if (resp == true) {
        let indice = filesAndDiligences.value.findIndex(
          (element) => element.DiligenciaID == diligenciaId
        );
        filesAndDiligences.value.splice(indice, 1);
      }
      loading.value = false;
    }

    const editDiligencia = (diligenciaId) => {
      changeNameInStore(formType.value);
      const scrollY = window.scrollY;
      const tabIndexQuery = tabIndex.value; 
      router.push({
        name: 'actuacion-edit-print',
          params: {
            pathName: actuacionType.value,
            id: diligenciaId
          },
          query: {
            scrollY,
            tabIndex: tabIndexQuery
          }
      });
    }

    const seeDiligencia = (diligenciaId) => {
      countPrint(diligenciaId);
      changeNameInStore(formType.value);
      const scrollY = window.scrollY;
      const tabIndexQuery = tabIndex.value; 
      router.push({
        path: `/actuaciones/${actuacionType.value}/print/${diligenciaId}`,
        query: {
          scrollY,
          tabIndex: tabIndexQuery
        }
      });
    }

    const countPrint = (DiligenciaID) => {
      let fullDate = new Date();

      let date = `${fullDate.getFullYear()}-${fullDate.getMonth() + 1
        }-${fullDate.getDate()} ${fullDate.getHours()}:${fullDate.getMinutes()}:00`;
      store.dispatch("sumario/addCounterPrint", {
        DiligenciaID: DiligenciaID,
        ComisariaID: user.value.dependencia,
        Paginas: 1,
        FechaIniVig: date,
      });
    }

    const fechaslash = (data) => {
      var fecha = new Date(data);
      return fecha.toLocaleDateString("es-AR");
    }

    const setData = (data) => {
      for (let i in data) {
        this[i] = data[i];
      }
    }

    const updateFiles = (event) => {
      if (!offline.onlineMode || resumen.value.ActuacionID.search("offline-") == 0) {
        toast.error("OFFLINE SIIS: No se pueden descargar o subir archivos en modo offline.");
        return;
      }
      formData.value = new FormData();
      event.files.map((file) => {
        if (
          file.type !== "application/pdf" &&
          file.type !== "image/jpeg" &&
          file.type !== "image/png"
        ) {
          err.value =
            "Al menos uno de los archivos es incompatible con los formatos permitidos (JPG, PNG y/o PDF)";
          RemoveFiles();
          FileUpload.value.clear();
          setTimeout(() => {
            err.value = false;
          }, 5000);
          return;
        }
        formData.value.append("userfile[]", file, file.name);
      });
    }
    const RemoveFiles = () => {
      formData.value = null;
    }

    const myUploader = async () => {
      if (
        user.value.userdata.tipoUsuario === "Dpto.Criminalistica" ||
        user.value.userdata.tipoUsuario === "Lab. Informatico Forense"
      ) {
        emailBody.value = "emailFileHtml";
        sendAllMails();
      }
      loading.value = true;
      try {
        if (!offline.onlineMode || resumen.value.ActuacionID.search("offline-") == 0) {
          toast.error("OFFLINE SIIS: No se pueden descargar o subir archivos en modo offline.");
          return;
        }
        let optionsPost = {
          url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/files/sumario?ActuacionID=${resumen.value.ActuacionID}`,
          formData: formData.value,
          headers: { "Content-Type": "multipart/form-data" },
        };
        await rest.post(optionsPost);
        await deleteGenericDataFromCached('files ' + sumario.value.id);
        await filesQuery();
        RemoveFiles();
        sortByDate();
      } catch (e) {
        console.error("err", e);
        err.value = "Error al subir archivos";
        setTimeout(() => {
          err.value = false;
        }, 5000);
        await filesQuery();
        RemoveFiles();
      }
    }
    const processFiles = (data) => {
      filesAndDiligences.value = [];
      for (let i = 0; i < sumario.value.diligencia.length; i++) {
        let diligence = { ...sumario.value.diligencia[i] };

        filesAndDiligences.value.push(diligence);
      }
      for (let i = 0; i < data.length; i++) {
        if (data[i].OrderTable !== null) {
          data[i].OrderTablePrint = data[i].OrderTable;
        } else {
          data[i].OrderTablePrint = null;
        }
        let file = { file: true, ...data[i], OrderTablePrint: data[i].OrderTable };
        filesAndDiligences.value.push(file);
      }
      if (
        orderBy.value.nombre === "Impresión" &&
        filesAndDiligences.value.some((item) => item.OrderTablePrint !== null)
      ) {
        sortTheOrderPrintNulls();
      } else {
        filesAndDiligencesByDate.value = filesAndDiligences.value.sort(sortByDate.value);
      }
      files.value = data;
    }

    const filesQuery = async (id = resumen.value.ActuacionID) => {
      if(!id){
        id = route.params.id
      }
      try {
        loading.value = true;
        let resp;
        let fdata = [];
        if (!offline.onlineMode) {
          toast.error("OFFLINE SIIS: No se pueden descargar o subir archivos en modo offline.");
        } else {
          resp = await rest.get({
            url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/files/sumario/?search={"ActuacionID": [{"operator": "=", "value": "${id}"}]}`,
          });
          fdata = resp.data.data; 
        }
        processFiles(fdata);
        loading.value = false;
      } catch (error) {
        console.log("filesQuery err", error);
      }
    }

    const $_TemplateForm_update = (field, value) => {
      emit("updateValue", field, value);
    }

    // elimina del array
    const $_TemplateParentForm_delete = (id) => {
      let arrId = id;
      arrId.value = null;
      store.dispatch("sumario/deleteDiligencia", arrId);
    }

    const viewFile = (file) => {
      return `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/files/sumario/${file.ActuacionArchivoID}?view=true`;
    }

    // const toastSuccess = () => {
    //  toast.success("Datos guardados");
    // }

    const inputDependencia = (event) => {
      let value = dependenciaList.value.filter(
        (item) => item.dependencia.toLowerCase().search(dataDependencia.value.toLowerCase()) >= 0
      );
      dependencia.value = value[0];
    }

    const filterDependencia = (event) => {
      filteredDependencia.value = dependenciaList.value.filter(
        (item) => item.dependencia.toLowerCase().search(event.query.toLowerCase()) >= 0
      );
    }

    const onRowReorder = (event) => {
      filesAndDiligences.value = event.value;
    }

    const sortByDate = (a, b) => {
      //Selecciono el tipo de ID por que si se trata de un archivo accedera a ActuacionArchivoID y DiligenciaID no existira; lo mismo a la inversa
      let aFiv;
      let bFiv;

      if (!a.Fechainivig || a.Fechainivig === undefined) {
        aFiv = "1999-01-01 00:00:00";
      } else {
        aFiv = a.Fechainivig;
      }
      if (!b.Fechainivig || b.Fechainivig === undefined) {
        bFiv = "1999-01-01 00:00:00";
      } else {
        bFiv = b.Fechainivig;
      }
      let id = a["DiligenciaID"] || a["ActuacionArchivoID"];
      if (id.search("offline-") === 0) return 1;
      var reA = /[^a-zA-Z]/g;
      var reN = /[^0-9]/g;
      var aA = aFiv.replace(reA, "");
      var bA = bFiv.replace(reA, "");
      if (aA === bA) {
        var aN = parseInt(aFiv.replace(reN, ""), 10);
        var bN = parseInt(bFiv.replace(reN, ""), 10);
        return aN === bN ? 0 : aN < bN ? 1 : -1;
      } else {
        return aA < bA ? 1 : -1;
      }
    }

    const sortByOrderTablePrint = (a, b) => {
      var reA = /[^a-zA-Z]/g;
      var reN = /[^0-9]/g;
      var aA = a.OrderTablePrint.replace(reA, "");
      var bA = b.OrderTablePrint.replace(reA, "");
      if (aA === bA) {
        var aN = parseInt(a.OrderTablePrint.replace(reN, ""), 10);
        var bN = parseInt(b.OrderTablePrint.replace(reN, ""), 10);
        return aN === bN ? 0 : bN < aN ? 1 : -1;
      } else {
        return bA < aA ? 1 : -1;
      }
    }

    const filterOrder = (event) => {
      filteredOrder.value = orderList.value.filter(
        (item) => item.nombre.toLowerCase().search(event.query.toLowerCase()) >= 0
      );
    }

    watch(
      () => DescripcionFinalizacion.value,
      (newValue) => {
        if (newValue.length >= 200) {
          errorDescripcion.value = 'Máximo de caracteres 200'
        }else{
          errorDescripcion.value = null
        }
      }
    );


    const handleFinalizarActuacion = async () => {
      closeModalTemplate(ModalRefEsclarecido)
      let data = {
        NuevoEstado: "Finalizada",
        Esclarecido: isEsclarecido.value,
        DescripcionFinalizacion: DescripcionFinalizacion.value
      };
      loading.value = true;
      try {
        let request = await axios.put(
          `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/estado-actuacion/${sumario.value.id}`,
          data,
          { withCredentials: true, params: { method: "own" } }
        );
        if (request.data.error === "") {
          let icon = {
            type: "pi pi-check-circle",
            style: "font-size: 3em; color: rgb(89, 150, 29);",
          };
          let msg = "¡La actuación se finalizó correctamente!";
          finalizarCambioEstado(msg, icon, true, false, "/actuaciones/list");
        }
      } catch (e) {
        let icon = { type: "pi pi-exclamation-circle", style: "font-size: 3em; color: red;" };
        let msg = "La Actuacion No se pudo Finalizar";
        finalizarCambioEstado(msg, icon, true, true);
      }
      isEsclarecido.value = null,
      DescripcionFinalizacion.value = ''
      loading.value = false;
    }
    const updateOrderTableDataBase = () => {
      let i = 1;
      filesAndDiligences.value.map((item) => {
        if (item.file === undefined) {
          let payload = { OrderTablePrint: i, diligenciaID: item.DiligenciaID, name: item.Nombre };
          filesAndDiligences.value[i - 1].OrderTablePrint = i.toString();
          store.dispatch("sumario/editOrderTablePrintFromDiligencia", payload);
          i++;
        }
        if (item.file === true) {
          let payload = {
            OrderTablePrint: i,
            ActuacionArchivoID: item.ActuacionArchivoID,
            name: item.Filename,
            FechaCreacion: item.FechaCreacion,
            Extension: item.Extension,
          };
          filesAndDiligences.value[i - 1].OrderTablePrint = i.toString();
          store.dispatch("sumario/editOrderTableForFiles", payload);
          i++;
        }
      });
    }
    const sortTheOrderPrintNulls = () => {
      let i = 1;
      filesAndDiligencesByDate.value = filesAndDiligences.value.sort(sortByDate).reverse();
      let amountOfNullOrderPrints = filesAndDiligencesByDate.value.filter(
        (fileOrDiligence) => fileOrDiligence.OrderTablePrint === null
      ).length;
      const newOrdenPrint = filesAndDiligencesByDate.value.length - amountOfNullOrderPrints;
      filesAndDiligencesByDate.value.map((fileOrDiligence) => {
        if (fileOrDiligence.OrderTablePrint === null) {
          fileOrDiligence.OrderTablePrint = (newOrdenPrint + i).toString();
          i++;
        }
      });
      filesAndDiligences.value = filesAndDiligencesByDate.value.sort(sortByOrderTablePrint);
    }

    // const updateSumario = async (id) => {
    //   await store.dispatch("sumario/setSumario", id);
    // }

    const openModalTemplate = (type) => {
      type.value?.open();
    }
    
    const closeModalTemplate = (type) => {
      if(type.value){
        type.value?.close();
      }else{
        type.close()
      }
    }

    const openModalEsclarecido = () => {
      openModalTemplate(ModalRefEsclarecido)
      closeModalTemplate(ModalRefConfirm)
    }

    const verifyAmountOfDiligences = () => {
      if (filesAndDiligences.value.length >= 3) {
        openModalTemplate(ModalRefConfirm);
      } else {
        openModalTemplate(ModalRefInform);
      }
    }
    const goToActuationEditMode = async () => {
      setAfectationCardDisabled(false);
      setPersonsAndEffectDisabled(false);
      await changeNameInStore(formType.value);
      store.dispatch("editMode/prepareActuationForEdition", sumario.value);
      store.dispatch("sumario/setEditMode", true);
      router.push("/actuaciones/edit/" + actuacionType.value + "/initial");
    }

    const goToNotifications = () => {
      let { id } = route.params;
      router.push("/actuaciones/notificaciones/" + id);
    }
    const changeNameInStore = (formType) => {
      const viewConfig = actuacionesConfig.find((config) => config.path === "/actuaciones/view/");
      if (viewConfig && viewConfig.actuaciones) {
        const foundActuacion = viewConfig.actuaciones.find(
          (actuacion) => actuacion.nameInStore === formType
        );

        if (foundActuacion) {
          actuacionType.value = foundActuacion.pathName;
        } else {
          console.log(
            "No se encontró ninguna coincidencia para el formType proporcionado en /actuaciones/view/."
          );
          actuacionType.value = null;
        }
      } else {
        console.log("No se encontró la configuración para /actuaciones/view/.");
      }
    }

    const goToAgregarDiligencia = () => {
      changeNameInStore(formType.value);
      const scrollY = window.scrollY;
      const tabIndexQuery = tabIndex.value; 
      if (actuacionType.value) {
        router.push({
        path: `/actuaciones/new/${actuacionType.value}/${sumario.value.id}/addDiligencia`,
        query: {
          scrollY,
          tabIndex: tabIndexQuery
        }
      });
      } else {
        console.log("No se pudo encontrar un pathName para formType:", formType.value);
      }
    }


    //revisar esto, es para accede a $rest.sendEmail de siis_utils
    const { proxy } = getCurrentInstance();
    const $rest = proxy.$rest;

    const emailBodyContent = computed(() => {
      return emailBody.value === 'emailEvidenceHtml' ? emailEvidenceHtml.value : emailFileHtml.value;
    });

    const sendMailToDependency = async (slotProps) => {
      indexEmailButtonDisabled.value = slotProps?.index;
      let emailAddressee = await getDependencyEmailFromStore();
      await $rest.sendEmail({
        sender: "siisadmin@policia.sanjuan.gob.ar",
        addressee: [emailAddressee],
        subject: generateEmailSubject(),
        emailBody: emailBodyContent.value,
      });
      indexEmailButtonDisabled.value = null;
    }

    const generateEmailSubject = () => {
      if (user.value.userdata.tipoUsuario === "Dpto.Criminalistica") {
        return sumario.value.causaNumero + " - PERICIA CRIMINALÍSTICA";
      }
      if (user.value.userdata.tipoUsuario === "Lab. Informatico Forense") {
        return sumario.value.causaNumero + " - INFORME TÉCNICO LABORATORIO INFORMÁTICO FORENSE";
      }
      return sumario.value.causaNumero + " ";
    }

    const getDependencyEmailFromStore = async () => {
      await store.dispatch("sumario/getDependencyEmail", sumario.value.dependenciaID);
      return sumario.value.dependencyEmail;
    }

    const determineEmailButtonVisibility = (buttonData) => {
      let isFile = buttonData.file;
      if (!isFile) return false;
      switch (buttonData.TipoUsuario) {
        case "Dpto.Criminalistica":
          return user.value.userdata.tipoUsuario === "Dpto.Criminalistica" ? true : false;
        case "Lab. Informatico Forense":
          return user.value.userdata.tipoUsuario === "Lab. Informatico Forense" ? true : false;
        case "":
          return false;
        default:
          return false;
      }
    }

    const getDefaultEvidence = async () => {
      evidence.value = "";
      let resp = await rest.get({
        url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/actuacion-evidencia?search={"ActuacionID":[{"operator":"=","value":"${resumen.value.ActuacionID}"}]}`,
      });
      if (resp.data.data[0]?.Url !== undefined) {
        evidence.value = ensureHTTP(resp.data.data[0]?.Url).replace(/\s+/g, "");
      }
    }

    const showEmailSucessMessage = () => {
      toast.success("El e-mail fue enviado con éxito");
    }

    const copyToClipboard = () => {
      if (navigator?.clipboard) {
        copyToClipboardWithNavigator();
      } else {
        copyToClipboardWithExecCommand();
      }
    }

    const ensureHTTP = (url) => {
      if (!url.includes("https://") && !url.includes("http://")) {
        return "https://" + url;
      }
      return url;
    }

    const showCopyToClipboardToast = () => {
      toast.success("Url copiada en el portapapeles");
    }

    const copyToClipboardWithExecCommand = () => {
      var textArea = document.createElement("textarea");
      textArea.value = evidence.value;
      textArea.style.position = "absolute";
      textArea.style.opacity = "0";
      textArea.style.pointerEvents = "none";
      textArea.style.zIndex = "-1";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "exitoso" : "fallido";
        if (msg === "exitoso") showCopyToClipboardToast();
      } catch (err) {
        console.error("Error al intentar copiar el texto: ", err);
      }
    }

    const copyToClipboardWithNavigator = () => {
      navigator.clipboard
        .writeText(evidence.value)
        .then(() => {
          showCopyToClipboardToast();
        })
        .catch(function (err) {
          console.error("Error al copiar el texto: ", err);
        });
    }

    const showEmailErrorMessage = () => {
      toast.success(`
        No se puede enviar el email. Comuníquese con la
        <a
          href="https://api.whatsapp.com/send/?phone=542644446909&text=Hola%20estoy%20utilizando%20el%20SIIS,%20no%20puedo%20enviar%20correo%20electr%C3%B3nico%20de%20"
          target="_blank"
          style="text-decoration: none; color: inherit;"
        >
          <u>Mesa de Ayuda.</u>
        </a>
      `);
    }

    const getDate = (obj) => {
      const dateStr = obj.Fechainivig || obj.FechaCreacion;
      if (dateStr) {
        return unifyDateFormat(dateStr);
      }
      return "Invalid Date";
    }

    const unifyDateFormat = (dateStr) => {
      const format1 = /^\d{1,2}\/\d{1,2}\/\d{4} \d{2}:\d{2}:\d{2}$/;
      const format2 = /^\d{1,2}-\d{1,2}-\d{2} \d{2}:\d{2}:\d{2}$/;
      const format3 = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
      if (format1.test(dateStr)) {
        const [date, time] = dateStr.split(" ");
        const [day, month, year] = date.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}T${time}`;
      } else if (format2.test(dateStr)) {
        const [date, time] = dateStr.split(" ");
        const [day, month, year] = date.split("-");
        return `20${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}T${time}`;
      } else if (format3.test(dateStr)) {
        return dateStr.replace(" ", "T");
      } else {
        return "Invalid Date";
      }
    }
    //-----hay dos funciones con el mismo nombre, deberiamos revisar cual es la que va
    // const sortByDate = () => {
    //   filesAndDiligencesByDate.value = filesAndDiligences.value.sort((a, b) => {
    //     const dateA = new Date(this.getDate(a));
    //     const dateB = new Date(this.getDate(b));
    //     return dateB - dateA;
    //   });
    // }
    const sendMailToUFIAndMpftesting = async () => {
      let translatedFormTypeName = generalFunctions.translateNameFromFormType(formType.value);
      let emailUFI = viewData.value[translatedFormTypeName].emailUFI;
      if (emailUFI === undefined) return;
      if (process.env.VUE_APP_BACKEND_ENVIRONMENT.includes("siis.policiadesanjuan.gob.ar")) {
        await $rest.sendEmail({
          sender: "siisadmin@policia.sanjuan.gob.ar",
          addressee: [emailUFI, "mpftesting.24@gmail.com"],
          subject: generateEmailSubject(),
          emailBody: emailBody.value,
        });
      }
    }

    const sendAllMails = async (slotProps) => {
      await sendMailToDependency(slotProps);
      await sendMailToUFIAndMpftesting();
    }

    const determineActionButtonsVisibility = (item) => {
      let itemIsVisible = true;
      if (item.data.TipoUsuario === "Dpto.Criminalistica") {
        itemIsVisible = $rest.esTipoUsuario(
          [
            "Dpto.Criminalistica",
            "Lab. Informatico Forense",
            "User Tester",
            "Super User",
            "Ayudante Fiscal",
            "Fiscal",
            "Fiscal General",
            "Supervisor",
            "Fiscal General",
            "Administrativo",
            "Policia Investigador",
          ],
          user.value
        );
      }
      return itemIsVisible;
    }

    const loadCausaCartulas = () => {
      let simpleCausaCaratula = resumen.value.caratula && !evaluateIfFormTypeIsUFI() ? true : false ;
      let multipleCausaCaratula = resumen.value.listaCaratulas ? true : false ;
      let delito = evaluateIfFormTypeIsUFI();
      let expediente = resumen.value.listaArticulos ? true : false ;
      //it's multipleCausaCaratula discard option
      if(!simpleCausaCaratula && !delito &&  !expediente) multipleCausaCaratula = true;
      let array = {
        //the default 'blankArray' prevents a warning
        arrayName: 'blankArray',
      };
      if(multipleCausaCaratula){
        array = {
          arrayName: 'listaCaratulas',
          id: 'TipocausacaratulaID',
          attribute1: {text: '', prop: 'Nombre'},
          attribute2: {text: '', prop: ''},
        } ;
      }
      if(delito){
        array = {
          arrayName: 'crimes',
          id: 'TipocausacaratulaID',
          attribute1: {text: '', prop: 'Nombre'},
          attribute2: {text: '', prop: ''},
        };
      }
      if(expediente){
        array = {
          arrayName: 'articulos',
          id: 'ArticulosID',
          attribute1: {text: 'Art   ', prop: 'Numeroarticulo'},
          attribute2: {text: ' - ', prop: 'Codigo'},
        } ;
      }
      arrayCausaCaratula.value = array
      return array
    }

    const getItems = () => {
      const formTypesPermitidos = [
        "Unidades Fiscales de Investigación Delitos Contra la Propiedad por Denuncia",
        "Unidades Fiscales de Investigación Delitos Genéricos por Denuncia",
        "Unidades Fiscales de Investigacion Flagrancia",
        "Unidades Fiscales de Investigación Delitos Genéricos por Oficio",
        "Unidades Fiscales de Investigación Delitos Contra la Propiedad por Oficio"
      ];
      const tipoUsuario = user.value.userdata.tipoUsuario;
      const estadoActuacion = sumario.value?.sumarioEstado;
      const esFinalizada = estadoActuacion === "Finalizada";
      const permisos = permisosPorUsuario[tipoUsuario] || [];
      return permisos
        .filter((accion) => {
          if (accion === "Finalizar instrucción" && esFinalizada) {
            return false;
          }
          if (accion === "Cambiar tipo de actuación" && !formTypesPermitidos.includes(formType.value)) {
            return false;
          }
          return true;
        })
        .map((accion) => {
          return {
            ...acciones[accion],
            command: () => {
              acciones[accion].command();
            },
          };
        });
    }
    const editarActuacion = async () => {
      await store.dispatch("sumario/setSumario", sumario.value.ActuacionID);
      changeNameInStore(formType.value);
      store.dispatch("editMode/prepareActuationForEdition", sumario.value);
      store.dispatch("sumario/setEditMode", true);
      router.push("/actuaciones/edit/" + actuacionType.value + "/initial");
    }

    const switchActuacion = async () => {
      isConfirmDisabled.value = true;
      const data = {
          "Fechainicio": sumario.value.fechaCertificadoDenuncia,
          "Numero": resumen.value.numeroSumario,
          "DenunciaID": resumen.value.ActuacionID,
          "TiposumarioID": actuacionIDforChange.value,
          "DependenciaID": sumario.value.DependenciaID
      }
      try {
        let request = await axios.put(
          `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/sumario/${sumario.value.id}?method=methodCommon`,
          data,
          { withCredentials: true}
        );
        if (request.data.error === "") {
          ModalRefSwitchActuacion.value.close()
          toast.success("Se cambio el tipo de actuación");
          setTimeout(() => {
            location.reload()
          }, 1500) 
        }
      } catch (error) {
        ModalRefSwitchActuacion.value.close()
        toast.error("Error: No se realizó el cambio de actuación");
      } finally {
        isConfirmDisabled.value = false;
      }
    }

    const onSave = () => {
      router.push(
        "/actuaciones/new/" + actuacionType.value + "/initial"
      );
    }

    const confirmDelete = (file, type) => {
      fileData.value = file;
      itemTypeToDelete.value = type
      modalRefMessage.value = `¿Está seguro de que desea eliminar ${type === 'archivo' ? "este archivo": "esta diligencia"}?`
      ModalRefDelete.value.open();
    }

    const deleteConfirmed = (isActuacion) => {
      if(isActuacion){
        deleteActuacion()
        return
      }
      if (fileData.value && itemTypeToDelete.value === 'archivo') {
        deleteFile(fileData.value); 
      }else if(fileData && itemTypeToDelete.value === 'diligencia'){
        deleteDiligencia(fileData.value); 
      }
      ModalRefDelete.value.close();
      fileData.value = null; 
      itemTypeToDelete.value = null
    }

    const cancelDelete = () => {
      fileData.value = null;
      itemTypeToDelete.value = null
      ModalRefDelete.value.close();
    }

    const handleShareActuacion = async (confirm) => {
      if(confirm){
        closeModalTemplate(ModalShareConfirm)
        try { 
          const formData = new FormData();
          formData.append('action', 'share');
          formData.append('SumarioID', sumario.value?.id);
          formData.append('UsuarioID', user.value.uid);
          formData.append('DependenciaID', dependenciaForShare.value);
          const optionsPost = {
            url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/actuacion-usuario-dependencia?method=own`,
            formData
          }
          await rest.post(optionsPost)
        } catch (error) {
          console.error(error);
          toast.error('No se pudo compartir la instrucción')
        } finally{
          dependenciaForShare.value = null
          closeModalTemplate(ModalShareConfirm)
        }
        return
      }
      closeModalTemplate(ModalRefShare)
      openModalTemplate(ModalShareConfirm)
    }

    watch(
      () => orderBy.value,
      () => {
        if (orderBy.value.nombre === 'Fecha') {
          sortByDate();
        } else if (
          orderBy.value.nombre === 'Impresión' &&
          filesAndDiligences.value.some(item => item.OrderTablePrint !== null)
        ) {
          sortTheOrderPrintNulls();
        } else {
          filesAndDiligences.value = filesAndDiligences.value.sort(sortByDate);
        }
      }
    );

    watch(
      () => resumen.value.ActuacionID,
      (newVal) => {
        if (newVal !== null) {
          getDefaultEvidence();
        }
      }
    );

    return {
      // Refs
      FechaUbiRef,
      FileUpload,
      modalUpdateRef,
      ModalRefEsclarecido,
      ModalRefConfirm,
      ModalRefInform,
      ModalRefSwitchActuacion,
      msjEnable,
      mensaje,
      buttomAceptar,
      buttomCancelar,
      iconModal,
      aceptarLabel,
      cancelarLabel,
      ClickAceptar,
      prosecutorUserTypes,
      filesAndDiligences,
      loading,
      orderBy,
      err,
      formType,
      actuacionType,
      modalRefMessage,
      modalUpdateRef,
      ModalRefConfirm,
      ModalRefDelete,
      ModalRefEsclarecido,
      displayConfirmation,
      isDisabled,
      selectorDisabled,
      actuacionIDforChange,
      isConfirmDisabled,
      files,
      disabledModifyStatusActuation,
      anios,
      selectedDropdownValue,
      response,
      causaJuzgado,
      causaCaratula,
      headerModal,
      ufiInterviniente,
      assistants,
      prosecutor,
      sumarioEstado,
      nroActuacion,
      listaCaratulas,
      ModalDropdown,
      ModalInputText,
      crimes,
      tabIndex,
      ModalRefShare,
      errorDescripcion,
      articulos,
      dependenciaForShare,

      // Computeds
      resumen,
      sumario,
      user,
      juzgadoResumen,
      ufiResumen,
      fiscalResumen,
      assistantResumen,
      yearResumen,
      sitioResumen,
      legajoNroResumen,
      orderList,
      filteredOptions,
      filteredDependencia,
      arrayArticulos,
      arrayCausaCaratula,
      caratulasResumen,
      usersAllowedToEdit,
      mostrarPersonalInterviniente,
      dataDependencia,
      ModalRefSendDependency,
      dataArticulos,
      dataCaratulas,
      dataCrimes,
      translateNameFromFormType,
      isForensicOrCriminology,
      datosCargados,
      dependenciasFiltradas,
      ModalShareConfirm,

      // Reactive states
      DescripcionFinalizacion,
      isEsclarecido,
      evidence,
      displayModal,
      modalSpinner,
      modalAttributes,
      confirmationMode,
      allowEmptySave,
      blankArray,

      // Methods
      onTabChange,
      activarProrroga,
      changeStatusActuacion,
      handleFinalizarActuacion,
      seeDiligencia,
      editDiligencia,
      confirmDelete,
      deleteConfirmed,
      cancelDelete,
      goToAgregarDiligencia,
      updateOrderTableDataBase,
      myUploader,
      updateFiles,
      formatNameUFI,
      colorActive,
      RemoveFiles,
      btnEnvio,
      openModalTemplate,
      getActuationsForTanstack,
      getActuationsForTanstackByPage,
      getActuationFromCache,
      getItems,
      saveActuationInCache,
      isOnlineActuacion,
      authorizedUserActuacion,
      onRowReorder,
      filterDependencia,
      onSave,
      apellidoNombre,
      determineActionButtonsVisibility,
      determineEmailButtonVisibility,
      indexEmailButtonDisabled,
      authorizedUserDiligencia,
      getGenericDataFromCache,
      saveGenericDataInCache,
      verifyAmountOfDiligences,
      openModalEsclarecido,
      closeModalTemplate,
      deleteGenericDataFromCached,
      fechaCreacion,
      viewFile,
      switchActuacion,
      loadCausaCartulas,
      showEmailErrorMessage,
      copyToClipboard,
      showEmailSucessMessage,
      showMo,
      saveModalData,
      isSaveDisabled,
      openModal,
      closeModal,
      formatCausasCaratulas,
      loadModalAttributes,
      evaluateIfFormTypeIsUFI,
      formatArticulos,
      changeModal,
      deleteModalItem,
      ModalConfirmDeleteActuacion,
      getIcon,
      getIconColor,
      handleShareActuacion,
      secretarioActualString,
      secretarioOriginalString
    };
  }
});
</script>

<style scoped>

::v-deep(.p-input-icon-right>i){
  top: 65%;
}

.field{
  display: flex;
  flex-direction: column;
  gap: .1rem;
}
::v-deep(.p-tabview .p-tabview-nav) {
  display: flex !important;
  justify-content: center !important;
  background-color: transparent;
}

.danger__text {
  color: #ff0000;
}

.confirmation-content {
  padding: 10px;
  gap: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.selectorOption {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.hiddenSelector {
  visibility: hidden;
}

.enabledSelector {
  margin-right: 15px;
  width: 360px;
}

.vertical-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
}

.menuprint {
  border-bottom: 1px solid #6c757d;
}

ul {
  margin: 0 0 10px;
  list-style: none;
  padding: 0;
}

ul li {
  list-style: none;
  margin: 0 0 5px;
  padding: auto 0;
}

.detalleSumario h4 {
  margin: 0 0 5px;
}

.detalleSumario p {
  margin: 0 0 10px;
}

.p-button {
  height: 40px;
}

.p-fileupload-buttonbar {
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
}

.file-title {
  margin-top: 40px;
  margin-bottom: 20px;
}

.negative-mt {
  margin-top: -15px;
}

.input-order {
  min-width: 250px;
  margin-top: -17px;
}

.edit-pencil {
  margin-top: -10px;
  margin-left: 5px;
}

.articulo__nombre {
  width: 82%;
}

.listaArticulos {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  line-height: 0.9;
  font-size: smaller;
}

.containerArticulos {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 5px;
}

.btn {
  width: 18%;
}


::v-deep(.p-dialog-mask) {
  width: 100% !important;
}

.mt-buttons {
  margin-top: 30px;
}

.preloader {
  display: flex;
  justify-content: center;
  padding: 0;
  height: 45px;
  width: 45px;
  margin-bottom: 25px;
}

.preloaderSpinner {
  display: flex;
  justify-content: center;
  padding-top: 15rem;
}
.page {
  padding: 10px 30px;
  background-color: #f8f9fa;
  min-height: calc(100vh - 92px);
}
.content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.overlay-cargando {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
@/router/RoutesConfig/actuacionesConfig/actuacionesConfig
